import { MenuItem } from 'src/commons';
import { routes } from './routes';

export const publicationsMenu: MenuItem = {
  key: 'publications',
  basePath: '/publications',
  enabled: true,
  icon: 'List',
  text: 'Publications',
  children: routes,
};
